import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import VerifyNonce from "./VerifyNonce";

const VerifyNonceContainer: React.FC = () => {
    const { state, verifySetPasswordNonce } = useAuthenticationStore();
    const { isLoading, serverError, email } = state;
    const navigate = useNavigate();

    useEffect(() => {
        if (!email) {
            navigate("../" + AuthenticationViews.login);
        }
    }, [email, navigate]);

    const isValidNonce = (nonce: string) => {
        const cleaned = ("" + nonce).replace(/\D/g, "");
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `${match[1]}-${match[2]}-${match[3]}`;
        }
        return null;
    };

    console.log("VerifyNonceContainer: " + state.activeView);
    return (
        <VerifyNonce
            serverError={serverError}
            isLoading={isLoading}
            email={email}
            isValidNonce={isValidNonce}
            verifyNonce={(email, nonce) =>
                verifySetPasswordNonce(
                    email,
                    isValidNonce(nonce)!,
                    state.activeView === AuthenticationViews.initializePassword,
                )
            }
        />
    );
};

export default VerifyNonceContainer;
